import React from 'react';

const NavRadio = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20">
        <path d="M11.8 13.6v-1.1h3.3V.5H3.8v3.4H.4v12.7h5v-11H10v5.3H7.2v4.5h2.9v4.4h5.5v-6h-3.8zm-1.7-1.2v1.1H8.8v-1.1h1.3zm-8 2.4V5.5h1.7v9.4H2.1zm3.3-11V2.1h8v8.6h-1.6v-7H5.4zm6.4 14.1v-2.7h2.1v2.7h-2.1z" />
    </svg>
);

export default NavRadio;
